import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@shared/ui/molecules/Dialog';
import { closeDialog } from '@shared/store/dialog.duck';
import { TeamEntity } from '@shared/models/team.models';
import { reset, selectAddTeamMemberView, setSelectedTeam } from '../ducks/add-users.duck';
import { AddTeamMemberView } from '../ducks/AddUsers.model';
import { AddUser } from '../components/AddUser';
import { AddUserSuccess } from '../components/AddUserSuccess';
import { UserMovedSuccessfully } from '../components/UserMovedSuccessfully';
import { UserLimitReached } from '../components/UserLimitReached';

interface Props {
  payload?: {
    // Team to preselect in the add/move forms.
    team?: TeamEntity;
    // Called when the dialog closes so the host can refresh (e.g. reload members).
    onClose?: () => void;
  };
}

// Dialog version of the /manage/add-users flow: invite a new user or move an
// existing one, driven by the same add-users duck as the page.
export default function AddTeamMemberDialog(props: Props) {
  const dispatch = useDispatch();
  const view = useSelector(selectAddTeamMemberView);
  const team = props.payload?.team;

  useEffect(() => {
    dispatch(reset());
    if (team) {
      dispatch(setSelectedTeam(team));
    }
    return () => {
      dispatch(reset());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const close = () => {
    dispatch(closeDialog());
    props.payload?.onClose?.();
  };

  return (
    <Dialog isOpen={true} onClose={close}>
      {view === AddTeamMemberView.AddUser && <AddUser />}
      {view === AddTeamMemberView.UserAddedSuccessful && <AddUserSuccess onDone={close} />}
      {view === AddTeamMemberView.UserMovedSuccessful && <UserMovedSuccessfully onDone={close} />}
      {view === AddTeamMemberView.AtUserLimit && <UserLimitReached onDone={close} />}
    </Dialog>
  );
}
